var _defs, _g, _g2, _path, _g3, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect, _path9, _path0, _g4, _path1, _path10, _path11, _line, _rect2, _line2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderLogoBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uADF8\\uB8F9_398",
    "data-name": "\\uADF8\\uB8F9 398",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 194.203,
    height: 43,
    viewBox: "0 0 194.203 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_552",
    "data-name": "\\uC0AC\\uAC01\\uD615 552",
    width: 194.203,
    height: 43,
    fill: "#032155"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_543",
    "data-name": "\\uC0AC\\uAC01\\uD615 543",
    width: 142.944,
    height: 16.125,
    fill: "#032155"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_544",
    "data-name": "\\uC0AC\\uAC01\\uD615 544",
    width: 143.15,
    height: 5713.249,
    fill: "#032155"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_545",
    "data-name": "\\uC0AC\\uAC01\\uD615 545",
    width: 4.112,
    height: 4.112,
    fill: "#032155"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_397",
    "data-name": "\\uADF8\\uB8F9 397",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_396",
    "data-name": "\\uADF8\\uB8F9 396",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_395",
    "data-name": "\\uADF8\\uB8F9 395",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_385",
    "data-name": "\\uADF8\\uB8F9 385",
    transform: "translate(51.172 2.464)",
    style: {
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_384",
    "data-name": "\\uADF8\\uB8F9 384"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_383",
    "data-name": "\\uADF8\\uB8F9 383",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_526",
    "data-name": "\\uD328\\uC2A4 526",
    d: "M154.182,19.635c-1.792.073-3.71.145-5.067.127l-.307-1.81c1.864,0,3.42-.018,5.248-.09,2.009-.073,3.964-.217,5.393-.4l.181,1.7c-1.538.2-3.728.38-5.447.47M153.91,8.2c2.733,0,4.47,1.611,4.47,3.873,0,2.244-1.737,3.873-4.47,3.873-2.715,0-4.488-1.629-4.488-3.873,0-2.262,1.773-3.873,4.488-3.873m0,5.972a2.1,2.1,0,1,0-2.316-2.117,2.117,2.117,0,0,0,2.316,2.117m8.488,9.121h-2.1V7.166h2.1Z",
    transform: "translate(-148.807 -7.166)",
    fill: "#032155"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_527",
    "data-name": "\\uD328\\uC2A4 527",
    d: "M205.138,19.052v2.515h3.71v1.683H194.28V21.567h3.674V19.052h-1.81V13.713h8.76V11.849h-8.85V10.166H207V15.4h-8.759v1.955h9.23v1.7Zm-5.121,2.515h3.076V19.052h-3.076Z",
    transform: "translate(-178.643 -9.134)",
    fill: "#032155"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_528",
    "data-name": "\\uD328\\uC2A4 528",
    d: "M247.817,17.445l.253,1.629a26.8,26.8,0,0,1-5.357.416h-1.538V9.084h6.1v1.665h-3.981v7.076a20.55,20.55,0,0,0,4.524-.38m-1.43-2.715V13.048h2.769V7.456h1.972V22.549h-1.972V14.731ZM252.4,7.166h2.027V23.291H252.4Z",
    transform: "translate(-209.412 -7.166)",
    fill: "#032155"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_529",
    "data-name": "\\uD328\\uC2A4 529",
    d: "M290.811,8.27c2.642,0,4.181,2.371,4.181,5.773,0,3.366-1.538,5.737-4.181,5.737-2.624,0-4.163-2.352-4.163-5.737,0-3.4,1.539-5.773,4.163-5.773m0,1.7c-1.213,0-2.1,1.52-2.1,4.072,0,2.534.887,4.036,2.1,4.036,1.249,0,2.154-1.5,2.154-4.036,0-2.552-.905-4.072-2.154-4.072m6.606-2.805h2.1V23.291h-2.1Z",
    transform: "translate(-239.247 -7.166)",
    fill: "#032155"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_530",
    "data-name": "\\uD328\\uC2A4 530",
    d: "M341.026,17.536l.235,1.611a35.2,35.2,0,0,1-7.021.543l-1.539-.018V8.559h7.4v1.683h-5.32v2.733h4.633v1.683h-4.633V17.97a26.519,26.519,0,0,0,6.244-.434m2.262,5.755v-8.56h-2.7v-1.81h2.7V7.166h2.1V23.291Z",
    transform: "translate(-269.464 -7.166)",
    fill: "#032155"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_531",
    "data-name": "\\uD328\\uC2A4 531",
    d: "M395.9,17.755v1.032c3,.2,4.723,1.285,4.723,2.9,0,1.792-2.1,2.9-5.755,2.9-3.638,0-5.737-1.1-5.737-2.9,0-1.611,1.7-2.7,4.651-2.9V17.755H387.6v-1.7h14.569v1.7Zm4.615-2.28a7.64,7.64,0,0,1-5.646-3c-.814,1.593-3.077,2.787-5.628,3-.289-.561-.6-1.1-.887-1.647,2.516-.109,4.706-1.14,5.267-2.769H389.1V9.376h11.618v1.683h-4.542c.651,1.629,3.095,2.642,5.248,2.733Zm-5.665,4.959c-2.172,0-3.565.452-3.565,1.267,0,.778,1.394,1.231,3.565,1.231,2.19,0,3.619-.453,3.619-1.231,0-.815-1.43-1.267-3.619-1.267",
    transform: "translate(-305.482 -8.616)",
    fill: "#032155"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_532",
    "data-name": "\\uD328\\uC2A4 532",
    d: "M441.792,15.8a7.226,7.226,0,0,1-3.62-3.239,6.31,6.31,0,0,1-3.71,3.71l-1.285-1.683a5.521,5.521,0,0,0,3.872-5.23V7.98h2.208V9.247a5.248,5.248,0,0,0,3.728,4.9Zm-5.99,1.376h10.7v5.918H435.8Zm8.578,1.629h-6.443v2.642h6.443ZM446.5,16.4h-2.117V7.166H446.5Z",
    transform: "translate(-335.388 -7.166)",
    fill: "#032155"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_533",
    "data-name": "\\uD328\\uC2A4 533",
    d: "M480.177,15.672V8.089h2.117v2.262h3.366v-2.3h2.1v7.619Zm7.366,7.6c-3.475,0-5.483-1.285-5.483-3.239,0-2.009,2.009-3.276,5.483-3.276,3.529,0,5.556,1.267,5.556,3.276,0,1.954-2.026,3.239-5.556,3.239M485.66,12h-3.366v2.009h3.366Zm-1.448,8.035c0,.959,1.249,1.538,3.33,1.538,2.172,0,3.366-.579,3.366-1.538,0-.977-1.195-1.575-3.366-1.575-2.081,0-3.33.6-3.33,1.575m8.759-3.457h-2.1v-2.19h-2.3V12.74h2.3V11h-2.3V9.355h2.3V7.166h2.1Z",
    transform: "translate(-366.226 -7.166)",
    fill: "#032155"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_534",
    "data-name": "\\uD328\\uC2A4 534",
    d: "M528.725,18.857V15.979c-1.683.054-3.257.073-4.47.073-.09-.543-.181-1.122-.29-1.665a94.04,94.04,0,0,0,10.28-.489l.127,1.556c-1.1.181-2.3.29-3.547.38v3.022Zm.453-5.212c-2.353,0-4.09-1.23-4.09-3,0-1.7,1.738-2.968,4.09-2.968s4.035,1.267,4.035,3-1.683,2.968-4.035,2.968m-3.113,9.212V18.1h2.118v3.076H537.9v1.683Zm3.113-13.609c-1.231,0-1.955.724-1.955,1.43s.724,1.376,1.955,1.376c1.194,0,1.936-.67,1.936-1.376s-.742-1.43-1.936-1.43m3.275,7.239h3.076V7.166h2.118V19.635h-2.118V18.006h-3.076Z",
    transform: "translate(-394.956 -7.166)",
    fill: "#032155"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_388",
    "data-name": "\\uADF8\\uB8F9 388",
    transform: "translate(51.053 -2798.327)",
    style: {
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_387",
    "data-name": "\\uADF8\\uB8F9 387"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_386",
    "data-name": "\\uADF8\\uB8F9 386",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_535",
    "data-name": "\\uD328\\uC2A4 535",
    d: "M151.195,88.86a4.688,4.688,0,0,1-2.014-1.445,3.381,3.381,0,0,1-.717-1.956.394.394,0,0,1,.128-.285.414.414,0,0,1,.3-.128h2.476a.736.736,0,0,1,.383.089,1.371,1.371,0,0,1,.3.265,2.035,2.035,0,0,0,.825.845,2.972,2.972,0,0,0,1.513.334,3.363,3.363,0,0,0,1.71-.354,1.08,1.08,0,0,0,.59-.963.912.912,0,0,0-.3-.708,2.729,2.729,0,0,0-.953-.491,19.655,19.655,0,0,0-1.926-.491,8.263,8.263,0,0,1-3.527-1.444,3.311,3.311,0,0,1-1.169-2.722,3.614,3.614,0,0,1,.668-2.142,4.376,4.376,0,0,1,1.906-1.474,7.286,7.286,0,0,1,2.889-.531,6.933,6.933,0,0,1,2.967.59,4.9,4.9,0,0,1,1.916,1.484,3.232,3.232,0,0,1,.7,1.759.4.4,0,0,1-.413.413h-2.594a.809.809,0,0,1-.383-.079.748.748,0,0,1-.265-.256,1.3,1.3,0,0,0-.639-.766,2.934,2.934,0,0,0-2.643,0,1.04,1.04,0,0,0-.472.924.95.95,0,0,0,.265.688,2.353,2.353,0,0,0,.865.5,12.33,12.33,0,0,0,1.72.462,12.576,12.576,0,0,1,2.919.836,3.7,3.7,0,0,1,1.356,5.581,4.766,4.766,0,0,1-2.1,1.493,9.47,9.47,0,0,1-6.279-.029",
    transform: "translate(-148.463 2748.948)",
    fill: "#032155"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_536",
    "data-name": "\\uD328\\uC2A4 536",
    d: "M199.122,89.452a.477.477,0,0,1-.137-.354V76.324a.463.463,0,0,1,.147-.354.489.489,0,0,1,.344-.137h2.535a.514.514,0,0,1,.364.137.463.463,0,0,1,.147.354v4.737h4.835V76.324a.471.471,0,0,1,.491-.491h2.535a.471.471,0,0,1,.491.491V89.1a.471.471,0,0,1-.491.491h-2.535a.471.471,0,0,1-.491-.491V84.2h-4.835V89.1a.462.462,0,0,1-.147.354.512.512,0,0,1-.364.138h-2.535a.477.477,0,0,1-.354-.138",
    transform: "translate(-181.612 2748.572)",
    fill: "#032155"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_537",
    "data-name": "\\uD328\\uC2A4 537",
    d: "M251.3,76.446a.48.48,0,0,1-.138-.354V74.323a.471.471,0,0,1,.491-.491h2.358a.472.472,0,0,1,.491.491v1.769a.472.472,0,0,1-.491.491h-2.358a.478.478,0,0,1-.354-.138m.02,11.693a.477.477,0,0,1-.137-.354V78.549a.47.47,0,0,1,.491-.491h2.319a.47.47,0,0,1,.491.491v9.237a.49.49,0,0,1-.137.344.463.463,0,0,1-.354.147h-2.319a.477.477,0,0,1-.354-.138",
    transform: "translate(-215.845 2749.885)",
    fill: "#032155"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_538",
    "data-name": "\\uD328\\uC2A4 538",
    d: "M278.626,89.441a.472.472,0,0,1-.147-.344V76.323a.465.465,0,0,1,.147-.354.491.491,0,0,1,.344-.137h2.083a.669.669,0,0,1,.668.373l4.8,7.546V76.323a.464.464,0,0,1,.148-.354.49.49,0,0,1,.344-.137h2.358a.471.471,0,0,1,.491.491V89.078a.514.514,0,0,1-.138.364.463.463,0,0,1-.354.148h-2.1a.7.7,0,0,1-.649-.373l-4.8-7.272V89.1a.49.49,0,0,1-.137.344.464.464,0,0,1-.354.148H278.97a.471.471,0,0,1-.344-.148",
    transform: "translate(-233.769 2748.572)",
    fill: "#032155"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_539",
    "data-name": "\\uD328\\uC2A4 539",
    d: "M330,89.441a.472.472,0,0,1-.147-.344V76.323a.465.465,0,0,1,.147-.354.491.491,0,0,1,.344-.137h9.177a.47.47,0,0,1,.491.491v1.847a.491.491,0,0,1-.137.344.463.463,0,0,1-.354.147h-6.269v2.653h5.837a.463.463,0,0,1,.354.148.513.513,0,0,1,.138.363v1.71a.487.487,0,0,1-.138.344.462.462,0,0,1-.354.148h-5.837v2.732h6.426a.471.471,0,0,1,.491.491V89.1a.49.49,0,0,1-.137.344.464.464,0,0,1-.354.148h-9.335a.471.471,0,0,1-.344-.148",
    transform: "translate(-267.479 2748.572)",
    fill: "#032155"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_540",
    "data-name": "\\uD328\\uC2A4 540",
    d: "M383.285,80.906l-.959-1.683a8.605,8.605,0,0,0,4.633-2.932l-4.126.489-.38-1.738,5.447-.4a7.327,7.327,0,0,0,.326-1.122h-5.049V71.785h7.329c-.054,4.344-2.9,7.764-7.221,9.121m1.5,5.284V81.268H386.9v3.257h8.922v1.665Zm5.628-9.013V75.441h2.968V70.5H395.5V82.209h-2.117V77.178Z",
    transform: "translate(-301.905 2752.071)",
    fill: "#032155"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_541",
    "data-name": "\\uD328\\uC2A4 541",
    d: "M428.693,86.2V84.54h6.171V80.7H437V84.54h6.262V86.2Zm13.157-5.3c-2.208-.507-4.959-2.19-5.882-4.307-.832,2.171-3.655,3.818-5.863,4.307l-.959-1.719c2.624-.38,5.737-2.407,5.737-5.284v-.977h2.208V73.9c0,2.841,3.312,4.94,5.755,5.339Z",
    transform: "translate(-332.328 2750.482)",
    fill: "#032155"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_542",
    "data-name": "\\uD328\\uC2A4 542",
    d: "M484.486,82.969a9.6,9.6,0,0,1-3.547-4.452,8.813,8.813,0,0,1-3.855,4.8L475.8,81.757a8.45,8.45,0,0,0,4-7.438V71.857h2.19V74.21a8.014,8.014,0,0,0,3.728,7.167ZM486.929,70.5h2.117V86.625h-2.117Z",
    transform: "translate(-363.235 2752.071)",
    fill: "#032155"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_543",
    "data-name": "\\uD328\\uC2A4 543",
    d: "M524.242,87.082V81.634h4.325V80.278h-6.189v-1.7h14.568v1.7h-6.262v1.357h4.4v5.448ZM529.653,71.5c3.638,0,5.646,1.3,5.646,3.095s-2.009,3.131-5.628,3.131-5.647-1.339-5.647-3.131,2.027-3.095,5.628-3.095m0,4.579c2.135,0,3.475-.6,3.475-1.466,0-.905-1.267-1.484-3.475-1.484-2.172,0-3.438.579-3.438,1.484,0,.869,1.267,1.466,3.438,1.466M533,83.245h-6.66v2.19H533Z",
    transform: "translate(-393.797 2751.415)",
    fill: "#032155"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_544",
    "data-name": "\\uD328\\uC2A4 544",
    d: "M63.373,36.375a3.2,3.2,0,1,1-3.2,3.2,3.2,3.2,0,0,1,3.2-3.2",
    transform: "translate(-39.481 -23.866)",
    fill: "#032155"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_391",
    "data-name": "\\uADF8\\uB8F9 391",
    transform: "translate(19.476 27.711)",
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_390",
    "data-name": "\\uADF8\\uB8F9 390"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_389",
    "data-name": "\\uADF8\\uB8F9 389",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_545",
    "data-name": "\\uD328\\uC2A4 545",
    d: "M58.692,80.585a2.056,2.056,0,1,1-2.056,2.056,2.056,2.056,0,0,1,2.056-2.056",
    transform: "translate(-56.636 -80.585)",
    fill: "#032155"
  }))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_546",
    "data-name": "\\uD328\\uC2A4 546",
    d: "M46.87,0a2.056,2.056,0,1,1-1.955,2.152A2.056,2.056,0,0,1,46.87,0",
    transform: "translate(-29.468 0)",
    fill: "#032155"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_547",
    "data-name": "\\uD328\\uC2A4 547",
    d: "M50.308,4.673a.636.636,0,1,1-.721-.538.636.636,0,0,1,.721.538",
    transform: "translate(-32.177 -2.709)",
    fill: "#032155"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_548",
    "data-name": "\\uD328\\uC2A4 548",
    d: "M.229,36.454a2.056,2.056,0,1,1,.887,2.77,2.056,2.056,0,0,1-.887-2.77",
    transform: "translate(0 -23.187)",
    fill: "#032155"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_549",
    "data-name": "\\uD328\\uC2A4 549",
    d: "M8.752,95.091a2.056,2.056,0,1,1,2.842.617,2.057,2.057,0,0,1-2.842-.617",
    transform: "translate(-5.528 -60.312)",
    fill: "#032155"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_550",
    "data-name": "\\uD328\\uC2A4 550",
    d: "M63.524,117.2a2.056,2.056,0,1,1,1.955-2.152,2.056,2.056,0,0,1-1.955,2.152",
    transform: "translate(-40.265 -74.197)",
    fill: "#032155"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_551",
    "data-name": "\\uD328\\uC2A4 551",
    d: "M110.092,80.7a2.056,2.056,0,1,1-.875-2.773,2.056,2.056,0,0,1,.875,2.773",
    transform: "translate(-69.687 -50.976)",
    fill: "#032155"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_552",
    "data-name": "\\uD328\\uC2A4 552",
    d: "M101.785,22.079a2.056,2.056,0,1,1-2.842-.617,2.057,2.057,0,0,1,2.842.617",
    transform: "translate(-64.3 -13.867)",
    fill: "#032155"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_546",
    "data-name": "\\uC0AC\\uAC01\\uD615 546",
    width: 0.688,
    height: 13.954,
    transform: "translate(16.958 3.554) rotate(-27.03)",
    fill: "#032155"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_553",
    "data-name": "\\uD328\\uC2A4 553",
    d: "M41.652,59.51,30.6,50.413,44,45.388Zm-9.7-8.871,9.215,7.583,1.96-11.772Z",
    transform: "translate(-20.076 -29.78)",
    fill: "#032155"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_554",
    "data-name": "\\uD328\\uC2A4 554",
    d: "M60.147,81.187a2.056,2.056,0,1,1-2.908,0,2.056,2.056,0,0,1,2.908,0",
    transform: "translate(-37.161 -52.873)",
    fill: "#032155"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_394",
    "data-name": "\\uADF8\\uB8F9 394",
    transform: "translate(8.531 18.596)",
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_393",
    "data-name": "\\uADF8\\uB8F9 393"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_392",
    "data-name": "\\uADF8\\uB8F9 392",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_555",
    "data-name": "\\uD328\\uC2A4 555",
    d: "M26.864,54.078a2.056,2.056,0,1,1-2.056,2.056,2.056,2.056,0,0,1,2.056-2.056",
    transform: "translate(-24.808 -54.078)",
    fill: "#032155"
  }))))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_556",
    "data-name": "\\uD328\\uC2A4 556",
    d: "M28.319,54.68a2.056,2.056,0,1,1-2.908,0,2.056,2.056,0,0,1,2.908,0",
    transform: "translate(-16.278 -35.482)",
    fill: "#032155"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_557",
    "data-name": "\\uD328\\uC2A4 557",
    d: "M101.881,24.14a2.056,2.056,0,1,1-.875-2.773,2.056,2.056,0,0,1,.875,2.773",
    transform: "translate(-64.3 -13.867)",
    fill: "#032155"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_558",
    "data-name": "\\uD328\\uC2A4 558",
    d: "M27.1,44.828,8.844,37.556,6.012,18.106,21.439,5.929,39.7,13.2l2.832,19.449ZM9.779,36.818l17.153,6.831L41.424,32.21,38.764,13.94,21.611,7.108,7.119,18.547Z",
    transform: "translate(-3.945 -3.89)",
    fill: "#032155"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_128",
    "data-name": "\\uC120 128",
    y1: 4.21,
    x2: 15.968,
    transform: "translate(5.367 29.086)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_548",
    "data-name": "\\uC0AC\\uAC01\\uD615 548",
    width: 16.514,
    height: 0.688,
    transform: "translate(5.279 32.964) rotate(-14.773)",
    fill: "#032155"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_129",
    "data-name": "\\uC120 129",
    x2: 1.541,
    y2: 10.581,
    transform: "translate(21.532 29.768)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_549",
    "data-name": "\\uC0AC\\uAC01\\uD615 549",
    width: 0.688,
    height: 10.692,
    transform: "translate(21.192 29.817) rotate(-8.282)",
    fill: "#032155"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_550",
    "data-name": "\\uC0AC\\uAC01\\uD615 550",
    width: 0.688,
    height: 10.691,
    transform: "matrix(0.603, -0.798, 0.798, 0.603, 1.849, 14.484)",
    fill: "#032155"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderLogoBlack);
export default __webpack_public_path__ + "static/media/header_logo_black.071da2985a24254111f686bc78bbcf19.svg";
export { ForwardRef as ReactComponent };